// extracted by mini-css-extract-plugin
module.exports = {"background":"Filters_background__oA3Po","wrap":"Filters_wrap__SRKq2","label":"Filters_label__24VsD","filters":"Filters_filters__1lUrY","rigth":"Filters_rigth__3AlDr"};